var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-button",on:{"click":_vm.handleClick}},[_c('a-icon',{attrs:{"width":"24","height":"24","icon":"fluent:chat-28-regular"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }